import { SharedService } from 'src/app/utils/shared.service';
import { Component, OnInit, Input } from '@angular/core';
import Stepper from 'bs-stepper';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import * as CommonConstants from '../../../utils/common.constants';
import { MasterService } from 'src/app/masters/master.service';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { GridApi, GridOptions } from 'ag-grid-community';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import swal from 'sweetalert2';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { isThisSecond } from 'date-fns';


@Component({
  selector: 'app-add-transfer-detail',
  templateUrl: './add-transfer-detail.component.html',
  styleUrls: ['./add-transfer-detail.component.scss']
})
export class AddTransferDetailComponent implements OnInit {

  private stepper: Stepper;
  form: FormGroup;

  PARAM_KEY = [CommonConstants.TRANSFER_REUESTED_BY, CommonConstants.RELATIONSHIP,
  CommonConstants.TRANSFER_REASON, CommonConstants.TRANSFER_PLACE, CommonConstants.TRF_FILE_STATUS,
  CommonConstants.TRANSFER_GEN_EME_LEVEL, CommonConstants.TRANSFER_GEN_EME_TYPE, CommonConstants.BLOOD_GROUP,
  CommonConstants.RH_FACTOR, CommonConstants.TRANSFER_MED_PROCEDURE, CommonConstants.TRANSFER_MED_EME_LEVEL,
  CommonConstants.TRANSFER_MED_EME_TYPE, CommonConstants.TRANSFER_CONDITION_WAY, CommonConstants.TRANSFER_CONDITION_VEHICLE,
  CommonConstants.TRANSFER_CONDITION_CLASS, CommonConstants.TRANSFER_CONDITION, CommonConstants.TRANSFER_CONDITION_POSITION, CommonConstants.SPECIALIST, CommonConstants.HOSPITAL];

  MD_FILE_PARAM_KEY = [CommonConstants.TRANSFER, CommonConstants.PREFERRED_LOCATION,
  CommonConstants.ALLERGY, CommonConstants.ASSISTANCE, CommonConstants.TRANSFER_CONDITION];
  PARAM__CODE_KEY = [CommonConstants.ASSISTANCE_KIND,
    CommonConstants.ASSISTANCE_TYPE, CommonConstants.ASSISTANCE_ACTOR];
  ptype = [CommonConstants.PARTNER_HOSPITAL_TYPE, CommonConstants.PARTNER_PRACTITIONER_TYPE];
  requestedBy = [];
  relationship = [];
  reason = [];
  place = [];
  fileStatus = [];
  emergencyLevel = [];
  emergencyType = [];
  groupSanguin = [];
  rhesus = [];
  procedure = [];
  emergencyLevel1 = [];
  emergencyType1 = [];
  way = [];
  vehicle = [];
  transferClass = [];
  condition = [];
  position = [];
  countries = [];
  towns = [];
  kind = [];
  type = [];
  actor = [];
  specialist = [];
  hosptials = [];
  PreferredLocationDefs;
  allergiesDefs;
  assistanceDefs;
  conditonsDefs;
  preferredLocationRowData = [];
  allergiesRowData = [];
  assistanceRowData = [];
  conditionsRowData = [];
  frameworkComponents;
  allergiesGridApi: GridApi;
  preferredLocationGridApi: GridApi;
  assistanceGridApi: GridApi;
  conditionsGridApi: GridApi;
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }

  transferConditionList = [];
  preferredLocationList = [];
  allergiesList = [];
  assistanceList = [];
  medfiId;
  transfer = [];
  state$: Observable<object>;
  partnerList = [];
  hospitalList = [];
  specialistList = [];
  submitted = false;
  specialities: any;
  masterCodes: any;

  constructor(private formBuilder: FormBuilder, private masterService: MasterService, private medicalFileService: MedicalFileService,
    private modal: NgbModal, private route:Router, private sharedService: SharedService, public activatedRoute: ActivatedRoute,private toastrService: ToastrService) {
    this.getFormGroup();
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent
    }
    this.loadMaster();
   // stopEditingWhenGridLosesFocus
  }

  ngOnInit() {

    this.sharedService.medicalFileId$.subscribe(res => {
      this.medfiId = res;
    });

    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    })
    this.state$ = this.activatedRoute.paramMap
      .pipe(map(() => window.history.state));
    this.state$.subscribe(res => {
      if (res["row"]) {
        this.patchAskTransferValue(res["row"]);
        setTimeout(() => this.getMedicalFilesByKey(), 350);  //coutries & towns are not loaded
      } else {
        this.sharedService.medicalFileId$.subscribe(res => {
          this.medfiId = res;
          setTimeout(() => this.getMedicalFilesByKey(), 350);
        })
      }
    })
  }

  setPartners() {
    if (this.partnerList) {
      this.hospitalList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
      this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
    }
  }

  getMedicalFilesByKey() {
    this.medicalFileService.getMedicalFilesByKey(this.medfiId, this.MD_FILE_PARAM_KEY).subscribe(response => {
      let masterValues = response['result'];
      if(masterValues){
      this.transfer = masterValues[CommonConstants.TRANSFER];
      this.allergiesList = masterValues[CommonConstants.ALLERGY];
      this.assistanceList = masterValues[CommonConstants.ASSISTANCE] ? this.assistanceMapping(masterValues[CommonConstants.ASSISTANCE]) : null;
      this.transferConditionList = masterValues[CommonConstants.TRANSFER_CONDITION] ? this.transferConditionMapping(masterValues[CommonConstants.TRANSFER_CONDITION]) : null;
      this.preferredLocationList = masterValues[CommonConstants.PREFERRED_LOCATION] ? this.preferredLocationMapping(masterValues[CommonConstants.PREFERRED_LOCATION]) : null;
    }
    })
  }

  loadMaster() {
    this.masterService.getTown().subscribe(response => {
      if (response && response['result']) {
        this.towns = response['result'];
      }
    })
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];
      }

    })

    //Hospital and Specailist
    this.masterService.getPartnersByPartnerType(this.ptype);{

    }
    this.masterService.getParnterListByParnterTypes(this.ptype).subscribe(value => {
      this.partnerList = value['result'];
      this.setPartners();
      //this.filterPartnerTypes();    
    });


    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterValues = response['result'];
        this.requestedBy = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_REUESTED_BY);
        this.relationship = masterValues.filter(master => master.paramKey === CommonConstants.RELATIONSHIP);
        this.reason = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_REASON);
        this.place = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_PLACE);
        this.fileStatus = masterValues.filter(master => master.paramKey === CommonConstants.TRF_FILE_STATUS);
        this.emergencyLevel = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_GEN_EME_LEVEL);
        this.emergencyType = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_GEN_EME_TYPE);
        this.groupSanguin = masterValues.filter(master => master.paramKey === CommonConstants.BLOOD_GROUP);
        this.rhesus = masterValues.filter(master => master.paramKey === CommonConstants.RH_FACTOR);
        this.procedure = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_MED_PROCEDURE);
        this.emergencyLevel1 = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_MED_EME_LEVEL);
        this.emergencyType1 = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_MED_EME_TYPE);
        this.way = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_CONDITION_WAY);
        this.vehicle = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_CONDITION_VEHICLE);
        this.transferClass = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_CONDITION_CLASS);
        this.condition = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_CONDITION);
        this.position = masterValues.filter(master => master.paramKey === CommonConstants.TRANSFER_CONDITION_POSITION);
       // this.kind = masterValues.filter(master => master.paramKey === CommonConstants.ASSISTANCE_KIND);
        //this.type = masterValues.filter(master => master.paramKey === CommonConstants.ASSISTANCE_TYPE);
       // this.actor = masterValues.filter(master => master.paramKey === CommonConstants.ASSISTANCE_ACTOR);
        this.specialist = masterValues.filter(master => master.paramKey === CommonConstants.SPECIALIST);
        this.hosptials = masterValues.filter(master => master.paramKey === CommonConstants.HOSPITAL);
      }
    });
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
    this.masterService.getMastersCodesByParamKey(this.PARAM__CODE_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterCodes = response['result'];
        this.kind = masterCodes.filter(master => master.paramKey === CommonConstants.ASSISTANCE_KIND);
        this.type = masterCodes.filter(master => master.paramKey === CommonConstants.ASSISTANCE_TYPE);
        this.actor = masterCodes.filter(master => master.paramKey === CommonConstants.ASSISTANCE_ACTOR);
      }
    });
  }


  filterPartnerTypes() {
    if (!this.partnerList) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  get f() { return this.form.controls; }

  private getFormGroup() {
    this.form = this.formBuilder.group({
      'relatId': ['', Validators.required],
      'townId': ['', Validators.required],
      'reatrCode': ['', Validators.required],
      'prtieReferringId': ['', Validators.required],
      'prtieEscortId': ['', Validators.required],
      'cotryId': ['', Validators.required],
      'hospiId': new FormControl(),
      'staRecCode': ['', Validators.required],
      'medatVaMedicalOrientation': new FormControl(),
      'medatVaChoiceOfPlace': new FormControl(),
      'medatBlRequestNeedValidation': new FormControl(),
      'medatVaValidationNeedFrom': new FormControl(),
      'medatBlEmergency': new FormControl(),
      'asktrGroupsanguin1': new FormControl(),
      'asktrRhesus1': new FormControl(),
      'medatInvasiveProcedure': new FormControl(),
      'asktrGroupsanguin': new FormControl(),
      'medatVaGroupSanguin': new FormControl(),
      'asktrRhesus': new FormControl(),
      'medatVaGroupKellCelano': new FormControl(),
      'otherProceCode': new FormControl(),
      'medatBlAlertSms': new FormControl(),
      'medatBlAlertMail': new FormControl(),
      'medatBlAlertLetter': new FormControl(),
      'medatBlJointFile': new FormControl(),
      'emtypCode': new FormControl(),
      'emlvlCode': new FormControl(),
      'emtypCode2': new FormControl(),
      'emlvlCode2': new FormControl(),
      'medatVaKarCode': new FormControl(),
      'medfiId': new FormControl(),
      'emergencyType': new FormControl(),
      'emergencyType1': new FormControl(),
      'prtieId': new FormControl(),
      'medatVaRhesus': new FormControl()
    })
  }

  getPreferredLocationGrid() {
  
    this.PreferredLocationDefs = [
      { headerName: 'Date', field: 'medapDtRequest', cellEditor: 'agDateInput' },
      { headerName: 'cotryId', field: 'cotryId', hide: true },
      {
        headerName: 'Country', field: 'cotryDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.countries, dataColumn: 'cotryId', model: new Parameter(), objectData: ['cotryId', 'cotryDesc'] }
      },
      { headerName: 'townId', field: 'townId', hide: true },
      {
        headerName: 'Town', field: 'townDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.towns, dataColumn: 'townId', model: new Parameter(), objectData: ['townId', 'townDescEn'] }
      },
      { headerName: 'hospiId', field: 'hospiId', hide: true },
      {
        headerName: 'Hospital', field: 'hospiDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.hospitalList, dataColumn: 'hospiId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }
      },
      { headerName: 'spltyId', field: 'spltyId', hide: true },
      {
        headerName: 'Speciality', field: 'spltyDescEn', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.specialities, dataColumn: 'spltyId', model: new Parameter(), objectData: ['spltyId', 'spltyDescEn'] }
      },
      { headerName: 'prtieId', field: 'prtieId', hide: true },
      {
        headerName: 'Specialist', field: 'specialist', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.specialistList, dataColumn: 'prtieId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }
      },
      { headerName: 'reatrCode', field: 'reatrCode', hide: true },
      {
        headerName: 'Reason', field: 'reatrDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.reason, dataColumn: 'reatrCode', model: new Parameter(), objectData: ['id', 'value'] }
      },

      { headerName: 'Requester', field: 'medapVaRequestor' }
    ];
  }

  getAllergiesGrid() {
    this.allergiesDefs = [
      { headerName: 'Code', field: 'medalVaCode', },
      { headerName: 'Description', field: 'medalVaDesc' },
      { headerName: 'Substance', field: 'medalVaSubstance', },
      { headerName: 'Type', field: 'medalVaType' },
    ];
  }

  getConditionsGrid() {
    this.conditonsDefs = [
      { headerName: 'trwayCode', field: 'trwayCode', hide: true },
      {
        headerName: 'Way', field: 'trwayDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.way, dataColumn: 'trwayCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'trvehCode', field: 'trvehCode', hide: true },
      {
        headerName: 'Vehicle', field: 'trvehDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.vehicle, dataColumn: 'trvehCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'trclaCode', field: 'trclaCode', hide: true },
      {
        headerName: 'Class', field: 'trclaDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.transferClass, dataColumn: 'trclaCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'trconCode', field: 'trconCode', hide: true },
      {
        headerName: 'Condition', field: 'trconDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.condition, dataColumn: 'trconCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
      { headerName: 'trposCode', field: 'trposCode', hide: true },
      {
        headerName: 'Position', field: 'trposDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.position, dataColumn: 'trposCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
    ];
  }

  getAssistanceGrid() {
    this.assistanceDefs = [
      { headerName: 'askinId', field: 'askinId', hide: true },
      {
        headerName: 'Kind', field: 'askinDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.kind, dataColumn: 'askinId', model: new Parameter(), objectData: ['id', 'descriptionEn'] }
      },
      { headerName: 'astypId', field: 'astypId', hide: true },
      {
        headerName: 'Type', field: 'astypDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.type, dataColumn: 'astypId', model: new Parameter(), objectData: ['id', 'descriptionEn'] }
      },
      { headerName: 'asactId', field: 'asactId', hide: true },
      {
        headerName: 'Actor', field: 'asactDesc', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.actor, dataColumn: 'asactId', model: new Parameter(), objectData: ['id', 'descriptionEn'] }
      },
      { headerName: 'Number', field: 'medasNuAssistanceNumber' }
    ];
  }

  addNewPreferredLocationModal(modelId) {
    this.preferredLocationRowData = [];
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.PreferredLocationDefs) {
      this.getPreferredLocationGrid();
    }
  }

  addNewAllergiesModal(modelId) {
    this.allergiesRowData = [];
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.allergiesDefs) {
      this.getAllergiesGrid();
    }
  }

  addNewTransferConditionModal(modelId) {
    this.conditionsRowData = [];
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.conditonsDefs) {
      this.getConditionsGrid();
    }
  }

  addNewAssistanceModal(modelId) {
    this.assistanceRowData = [];
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.assistanceDefs) {
      this.getAssistanceGrid();
    }
  }

  onGridReadyAllergies(params) {
    this.allergiesGridApi = params.api;
    this.allergiesGridApi.sizeColumnsToFit();
  }

  onGridReadyPrefferedLocation(params) {
    this.preferredLocationGridApi = params.api;
    this.preferredLocationGridApi.sizeColumnsToFit();
  }

  onGridReadyConditions(params) {
    this.conditionsGridApi = params.api;
    this.conditionsGridApi.sizeColumnsToFit();
  }

  onGridReadyAssistance(params) {
    this.assistanceGridApi = params.api;
    this.assistanceGridApi.sizeColumnsToFit();
  }

  addNewPreferredLocationRow() {
    const newRow = {

    };
    this.preferredLocationRowData.push(newRow);
    this.preferredLocationGridApi.setRowData(this.preferredLocationRowData);
  }

  addNewAllergiesRow() {
    const newRow = { medalVaCode: '', medalVaDesc: '', medalVaSubstance: '', medalVaType: '' };
    this.allergiesRowData.push(newRow);
    this.allergiesGridApi.setRowData(this.allergiesRowData);
  }

  addNewConditionRow() {
    const newRow = { trwayCode: ' ', trwayDesc: '', trvehCode: '', trvehDesc: '', trclaCode: '', trclaDesc: '', trconCode: '', trconDesc: '', trposCode: '', trposDesc: '' };
    this.conditionsRowData.push(newRow);
    this.conditionsGridApi.setRowData(this.conditionsRowData);
  }

  addNewAssistanceRow() {
    const newRow = { askinId: '', askinDesc: '', astypId: '', astypDesc: '', asactId: '', asactDesc: '', medasNuAssistanceNumber: '' };
    this.assistanceRowData.push(newRow);
    this.assistanceGridApi.setRowData(this.assistanceRowData);
  }

  saveAssistance() {
    this.assistanceRowData = this.assistanceRowData.map(item => ({
      ...item,
      'medfiId': this.medfiId
    }));
    this.medicalFileService.saveAssistance(this.assistanceRowData).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        this.toastrService.success("Assistance Added Succesffully");
        response = this.assistanceMapping(response);
        this.modal.dismissAll();
        this.assistanceList = Object.values(this.assistanceList.reduce((acc, c) => (acc[c.medasId] = c, acc), {}));
        this.assistanceList = response;
      }
    })
  }

  assistanceMapping(response) {
    response=response.map(item => ({
      ...item,
      askinDesc: item.askinId && this.kind && this.kind.length > 0 ? this.kind.find(obj => +obj.id === +item.askinId).descriptionEn : null,
      astypDesc: item.astypId && this.type && this.type.length > 0 ? this.type.find(obj => +obj.id === +item.astypId).descriptionEn : null,
      asactDesc: item.asactId && this.actor && this.actor.length > 0 ? this.actor.find(obj => +obj.id === +item.asactId).descriptionEn : null,
    }));
    return response;
  }

  saveTransferConditions() {
    this.conditionsRowData = this.conditionsRowData.map(item => ({
      ...item,
      'medfiId': this.medfiId
    }));
    this.medicalFileService.saveTransferConditions(this.conditionsRowData).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        this.toastrService.success("Transfer Condition Added Succesffully");
        response = this.transferConditionMapping(response)
        this.modal.dismissAll();
        this.transferConditionList = Object.values(this.transferConditionList.reduce((acc, c) => (acc[c.trconId] = c, acc), {}));
        this.transferConditionList = response;
      }

    })
  }

  transferConditionMapping(response) {
    response = response.map(item => ({
      ...item,
      trwayDesc: item.trwayCode && this.way && this.way.length > 0 ? this.way.find(obj => +obj.id === +item.trwayCode).value : null,
      trvehDesc: item.trvehCode && this.vehicle && this.vehicle.length > 0 ? this.vehicle.find(obj => +obj.id === +item.trvehCode).value : null,
      trclaDesc: item.trclaCode && this.transferClass && this.transferClass.length > 0 ? this.transferClass.find(obj => +obj.id === +item.trclaCode).value : null,
      trconDesc: item.trconCode && this.condition && this.condition.length > 0 ? this.condition.find(obj => +obj.id === +item.trconCode).value : null,
      trposDesc: item.trposCode && this.position && this.position.length > 0 ? this.position.find(obj => +obj.id === +item.trposCode).value : null
    }));
    return response;
  }

  savePreferredLocation() {
    this.preferredLocationRowData = this.preferredLocationRowData.map(item => ({
      ...item,
      'medfiId': this.medfiId
    }));
    this.medicalFileService.savePreferredLocation(this.preferredLocationRowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Preferred Location Added Succesffully");
        let response = res["result"];
        let mappedMasterResult = this.preferredLocationMapping(response);
        this.modal.dismissAll();
        this.preferredLocationList.push(mappedMasterResult[0]);
        this.preferredLocationList = Object.values(this.preferredLocationList.reduce((acc, c) => (acc[c.medapId] = c, acc), {}));
      }
    })
  }

  preferredLocationMapping(response) {
    response = response.map(item => ({
      ...item,
      practionerDesc:item.prtieId ? this.specialistList.find(obj => +obj.partnerid === +item.prtieId).partnername : null,
      spltyDesc: item.spltyId ? this.specialities.find(obj => +obj.spltyId === +item.spltyId).value : null,
      hospiDesc: item.hospiId ? this.hospitalList.find(obj => +obj.partnerid === +item.hospiId).partnername : null,
      reatrDesc: item.reatrCode ? this.reason.find(obj => +obj.id === +item.reatrCode).value : null,
      cotryDesc: item.cotryId ? this.countries.find(obj => +obj.cotryId === +item.cotryId).cotryDesc : null,
      townDesc: item.townId ? this.towns.find(obj => +obj.townId === +item.townId).townDescEn : null
    }));
    return response;
  }

  saveAllergies() {
    this.allergiesRowData = this.allergiesRowData.map(item => ({
      ...item,
      'medfiId': this.medfiId
    }));
    this.medicalFileService.saveAllergies(this.allergiesRowData).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        this.toastrService.success("Allergy Added Succesffully");
        this.modal.dismissAll();
        this.allergiesList = Object.values(this.allergiesList.reduce((acc, c) => (acc[c.medalId] = c, acc), {}));
        this.allergiesList = response;
      }

    })
  }

  next() {
    this.submitted = true;
    if (this.form.invalid) {
      Swal.fire("Please fill all mandatory fields");
      return;

    }
    var stepper = new Stepper(document.querySelector('.bs-stepper'));
    stepper.to(2);
  }
  previous() {
    var stepper = new Stepper(document.querySelector('.bs-stepper'));
    stepper.to(1);
  }

  gotoLogistics() {
    var stepper = new Stepper(document.querySelector('.bs-stepper'));
    stepper.to(3);
  }
  backtoMedicalNeeds() {
    var stepper = new Stepper(document.querySelector('.bs-stepper'));
    stepper.to(2);
  }

  onTransferConditionRowSelect(modelId) {
    this.getConditionsGrid();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.conditionsRowData = this.transferConditionList;
  }

  onAllergiesRowSelect(modelId) {
    this.getAllergiesGrid();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.allergiesRowData = this.allergiesList;
  }


  onPreferredLocationRowSelect(modelId) {
    this.getPreferredLocationGrid();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.preferredLocationRowData = this.preferredLocationList;
  }

  onAssistanceRowSelect(modelId) {
    this.getAssistanceGrid();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.assistanceRowData = this.assistanceList;
  }

  saveTransfer() {
    this.form.patchValue({ medfiId: this.medfiId });
    this.medicalFileService.saveAskTransfer(this.form.value).subscribe(res => {
      if (res && res["result"]) {
        let response = res["result"];
        swal.fire("Success", res['message'] ? res['message'] : "Saved Successfully", 'success');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }
  addPreferPlace() {

  }

  patchAskTransferValue(row) {
    this.medfiId = row.medfiId;
    this.form.patchValue({
      'relatId': row.relatId ? +row.relatId : null,
      'townId': row.townId,
      'hospiId': row.hospiId,
      'staRecCode': row.staRecCode ? +row.staRecCode : null,
      'medatVaMedicalOrientation': row.medatVaMedicalOrientation,
      'medatVaChoiceOfPlace': row.medatVaChoiceOfPlace,
      'medatBlRequestNeedValidation': row.medatBlRequestNeedValidation,
      'medatVaValidationNeedFrom': row.medatVaValidationNeedFrom,
      'medatBlEmergency': row.medatBlEmergency,
      'asktrGroupsanguin1': row.asktrGroupsanguin1 ? +row.asktrGroupsanguin1 : null,
      'asktrRhesus1': row.asktrRhesus1 ? +row.asktrRhesus1 : null,
      'medatInvasiveProcedure': row.medatInvasiveProcedure ? +row.medatInvasiveProcedure : null,
      'asktrGroupsanguin': row.asktrGroupsanguin ? +row.asktrGroupsanguin : null,
      'medatVaGroupSanguin': row.medatVaGroupSanguin,
      'asktrRhesus': row.asktrRhesus ? +row.asktrRhesus : null,
      'medatVaGroupKellCelano': row.medatVaGroupKellCelano,
      'otherProceCode': row.otherProceCode,
      'medatBlAlertSms': row.medatBlAlertSms,
      'medatBlAlertMail': row.medatBlAlertMail,
      'medatBlAlertLetter': row.medatBlAlertLetter,
      'medatBlJointFile': row.medatBlJointFile,
      'cotryId': row.cotryId,
      'emtypCode': row.emtypCode ? +row.emtypCode : null,
      'emlvlCode': row.emlvlCode ? +row.emlvlCode : null,
      'emtypCode2': row.emtypCode2 ? +row.emtypCode2 : null,
      'emlvlCode2': row.emlvlCode2 ? +row.emlvlCode2 : null,
      'medatVaKarCode': row.medatVaKarCode,
      'reatrCode': row.reatrCode ? +row.reatrCode : null,
      'prtieReferringId': row.prtieReferringId,
      'prtieEscortId': row.prtieEscortId,
      'emergencyType': row.emergencyType,
      'emergencyType1': row.emergencyType1,
      'prtieId': row.prtieId,
      'medatVaRhesus': row.medatVaRhesus ? +row.medatVaRhesus : null,
      'medfiId': row.medfiId
    })
  }
  transferAction(confirmTransfer){
      this.modal.open(confirmTransfer, { size: 'lg', container: '.page-content' });
  }
  transferFiletoFTT(){
    swal.fire({
      title: 'Are you sure?',
      text: 'Medical file will go to files to treat status, Please Confirm!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, send it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {
        let jsonData={
          fileId:+this.medfiId,
          status:CommonConstants.FILE_FTT
        }
        this.medicalFileService.updateFileStatus(jsonData).subscribe(res => {
          if (res['result'] && res['code'] === "0") {
            swal.fire(
              'Moved!',
              'Medical file moved to files to treat status.',
              'success'
            )
          } else {
            swal.fire("Error", "Error Occured While updating file status", 'error');
          }
        },
        error => {
          swal.fire("Error", "Error Occured While updating file status", 'error');
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        
      }
    })
  }
  openMedicalFilePage(){
    this.route.navigate(["/addMedicalFiles"], {
      state: {
        transferMedfId: this.medfiId
      }
    });
  }
}
